import { Gift, Rocket, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { CampaignTheme } from '@/services/types';

interface CampaignPreviewProps {
  surface: 'banner' | 'interstitial';
  title: string;
  description: string;
  ctaText: string;
  theme: CampaignTheme;
}

const ICON_MAP = {
  sparkles: Sparkles,
  rocket: Rocket,
  gift: Gift,
} as const;

export function CampaignPreview({
  surface,
  title,
  description,
  ctaText,
  theme,
}: CampaignPreviewProps) {
  const Icon = theme.icon ? ICON_MAP[theme.icon] : Sparkles;

  return (
    <div
      data-testid={`${surface}-preview`}
      className="rounded-3xl border p-5 shadow-sm"
      style={{
        backgroundColor: theme.background,
        color: theme.foreground,
        borderColor: theme.accent,
      }}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] opacity-70">
            {surface === 'banner' ? 'Navbar banner' : 'Interstitial'}
          </p>
          <h3 className="text-lg font-semibold">{title || 'Preview title'}</h3>
          <p className="text-sm leading-6 opacity-80">
            {description || 'Preview description'}
          </p>
        </div>
        <div
          className="flex h-10 w-10 items-center justify-center rounded-full border"
          style={{
            backgroundColor: theme.accent,
            borderColor: theme.accent,
            color: theme.foreground,
          }}
          aria-hidden="true"
        >
          <Icon className="h-4 w-4" />
        </div>
      </div>

      <div className="mt-5">
        <Button
          type="button"
          style={{
            backgroundColor: theme.accent,
            color: theme.foreground,
          }}
        >
          {ctaText || 'Call to action'}
        </Button>
      </div>
    </div>
  );
}
